<template>
  <div>
    <md-tabs md-alignment="centered">
      <md-tab md-label="Ações">
        <Loading :loading="buscando" />
        <md-list v-if="!buscando" class="md-double-line">
          <p>Enviar uma ação para um equipamento</p>
          <div v-for="data in botoes" :key="data.id">
            <md-list-item>
              <md-icon
                class="md-primary"
                :style="{
                  ['background-color']: data.cor,
                  ['border-radius']: '2px',
                  ['min-height']: '2vh',
                  ['min-width']: '2vh',
                }"
              />
              <div class="md-list-item-text">
                <span>{{ data.nomeExibicao }}</span>
              </div>
              <div class="md-list-item-text">
                <md-button
                  v-if="enviando.id === data.id && enviando.status"
                  class="md-primary md-raised"
                >
                  Enviando...
                </md-button>

                <div
                  v-if="enviando.id !== data.id || !enviando.status"
                  class="md-layout md-gutter"
                >
                  <div class="md-layout-item">
                    <md-button
                      class="md-primary md-raised"
                      :md-ripple="false"
                      :disabled="enviando.status"
                      @click.prevent="dialogActive = true"
                      @click="dialogData = data"
                    >
                      Enviar ação
                    </md-button>
                  </div>
                  <div v-if="canSendSmsAction()" class="md-layout-item">
                    <md-button
                      class="md-primary md-raised"
                      :md-ripple="false"
                      :disabled="enviando.status"
                      @click.prevent="dialogSmsActive = true"
                      @click="dialogData = { ...data, acaoTipo: acaoTipo.sms }"
                    >
                      Enviar SMS
                    </md-button>
                  </div>
                </div>
              </div>
            </md-list-item>
          </div>
        </md-list>
      </md-tab>
      <md-tab md-label="Aguardando envio">
        <EquipamentoAuditoriaTab
          ref="auditoria"
          :equipamento-id.sync="equipamentoId"
          :status="[0]"
          :can-cancel="true"
        />
      </md-tab>
      <md-tab md-label="Histórico">
        <EquipamentoAuditoriaTab
          ref="auditoria2"
          :equipamento-id.sync="equipamentoId"
          :status="[1, 2, 3, 5]"
          :can-cancel="false"
        />
      </md-tab>
    </md-tabs>

    <md-dialog
      :md-active.sync="dialogActive"
      :md-click-outside-to-close="!enviando.status"
      :md-close-on-esc="!enviando.status"
    >
      <md-dialog-title>Tem certeza?</md-dialog-title>
      <md-dialog-content>
        Essa ação irá demorar de 1 a 5 minutos para ser executada, poderá ser
        cancelado antes.
      </md-dialog-content>
      <md-dialog-actions>
        <md-button :disabled="enviando.status" @click="dialogActive = false">
          cancelar
        </md-button>
        <md-button
          class="md-primary"
          :disabled="enviando.status"
          @click="prepareToSend(dialogData)"
        >
          enviar
        </md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog
      :md-active.sync="dialogSmsActive"
      :md-click-outside-to-close="!enviando.status"
      :md-close-on-esc="!enviando.status"
    >
      <md-dialog-title>Tem certeza?</md-dialog-title>
      <md-dialog-content>
        Essa ação não poderá ser cancelada, deseja continuar?.
      </md-dialog-content>
      <md-dialog-actions>
        <md-button :disabled="enviando.status" @click="dialogSmsActive = false">
          cancelar
        </md-button>
        <md-button
          class="md-primary"
          :disabled="enviando.status"
          @click="prepareToSend(dialogData)"
        >
          enviar
        </md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog
      :md-active.sync="parametroDialogForm"
      :md-click-outside-to-close="!enviando.status"
      :md-close-on-esc="!enviando.status"
    >
      <md-dialog-title>Parâmetro</md-dialog-title>

      <div class="p-5" style="text-align: center">
        <p class="md-subheading">
          Valor entre 0 a {{ dialogData && (dialogData.xMAX || 0) }}
        </p>
        <md-field>
          <label for="parametroToSend">Valor</label>
          <md-input
            id="parametroToSend"
            v-model.number="parametroToSend"
            type="number"
            name="parametroToSend"
          />
        </md-field>
      </div>

      <md-dialog-actions>
        <md-button
          class="md-accent"
          :disabled="enviando.status"
          @click="parametroDialogForm = false"
        >
          Cancelar
        </md-button>
        <md-button
          class="md-primary"
          :disabled="enviando.status"
          @click="() => enviarAcaoParametrizada(dialogData)"
        >
          Enviar
        </md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'

import { EventBus, Topics, Types } from '@/event-bus'
import { AcaoTipo } from '@/utils/constants'

import Loading from '../../components/Loading'
import auth from '../../utils/auth'
import http from '../../utils/http'
import EquipamentoAuditoriaTab from './EquipamentoAuditoriaTab'

export default {
  name: 'EquipamentoAcoes',
  components: { EquipamentoAuditoriaTab, Loading },
  mixins: [validationMixin],
  data() {
    return {
      acaoTipo: AcaoTipo,
      buscando: false,
      botoes: null,
      enviando: {
        id: null,
        status: false,
      },
      dialogActive: false,
      dialogSmsActive: false,
      dialogData: null,
      equipamentoId: null,
      parametroDialogForm: false,
      parametroToSend: null,
    }
  },
  methods: {
    async enviarAcaoParametrizada(data) {
      if (this.parametroToSend === null || this.parametroToSend === '') {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Valor inválido',
        })
        return
      }

      if (this.parametroToSend < 0 || this.parametroToSend > data.xMAX) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Valor menor que 0 ou maior que o permitido',
        })
        return
      }

      await this.enviarAcao(data, this.parametroToSend)
    },
    prepareToSend(data) {
      const { xMAX, yMAX } = data

      if (xMAX !== null && yMAX !== null) {
        this.dialogActive = false
        this.dialogSmsActive = false
        this.parametroDialogForm = true
        return
      }

      this.enviarAcao(data)
    },
    async enviarAcao({ id, acaoTipo }, valorParametrizado = null) {
      if (this.enviando.status) return

      this.enviando = {
        id,
        status: true,
      }

      try {
        await http.post(`equipamento/acao`, {
          equipamentoId: this.equipamentoId,
          botaoAcaoId: id,
          acaoTipo: acaoTipo || AcaoTipo.comandoBasico,
          valorParametrizado: valorParametrizado,
        })

        this.$emit('changeAcao')
      } finally {
        this.enviando = {
          id: null,
          status: false,
        }

        this.dialogActive = false
        this.dialogSmsActive = false
        this.parametroDialogForm = false
      }
    },
    canSendSmsAction() {
      return auth.canSendSmsAction()
    },
    async searchAcoes(id) {
      this.equipamentoId = id

      this.buscando = true
      this.botoes = (await http.get(`equipamento/${id}/botao`)).botoes

      this.$refs.auditoria.searchAcoes(id)
      this.$refs.auditoria2.searchAcoes(id)

      this.buscando = false
    },
  },
}
</script>
